import {
  EscritoFormInitialValues,
  EscritosFormValues
} from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import {
  adjuntosMapping,
  datosMapping,
  organismoOrigenMapping,
  intervinientesMapping,
  organoDestinoOrdenMapping,
  organoOrigenOrdenMapping,
  principalMapping,
  procedimientoMapping,
  resolucionMapping,
  subsanacionMapping,
  trasladoCopiasMapping
} from 'src/contexts/EscritoContext/EscritoMapping/CommonMapping'
import { Escrito } from 'src/interfaces/EscritosLegales/index'

function AsuntoMapping(escrito: Escrito): EscritosFormValues {
  const escritoForm: EscritosFormValues = { ...EscritoFormInitialValues }

  // DATOS PRINCIPALES
  principalMapping(escritoForm, escrito)

  // SUBSANACIÓN / RECHAZADOS
  subsanacionMapping(escritoForm, escrito)

  // ÓRGANO Y ORDEN
  organoDestinoOrdenMapping(escritoForm, escrito)

  // ÓRGANO ORIGEN - ÓRGANO Y ORDEN
  organoOrigenOrdenMapping(escritoForm, escrito)

  // DATOS
  datosMapping(escritoForm, escrito)

  // RESOLUCIÓN
  resolucionMapping(escritoForm, escrito)

  // PROCEDIMIENTO
  procedimientoMapping(escritoForm, escrito)

  // DOCUMENTO PRINCIPAL Y ADJUNTOS
  adjuntosMapping(escritoForm, escrito)

  // ORGANISMO ORIGEN
  organismoOrigenMapping(escritoForm, escrito)

  // INTERVINIENTES
  intervinientesMapping(escritoForm, escrito)

  // TRASLADO DE COPIAS
  trasladoCopiasMapping(escritoForm, escrito)

  return escritoForm
}

export default AsuntoMapping
